/** @jsx h */
import { h } from 'preact'
import HeartLogo from './heart-logo'
import SpeedyGift from './speedy-gift'
import getComponent from '../utils/get-component'

const Wrapper = getComponent('flex items-center')

export default props => {
  const { heart, speedy } = props
  return (
    <Wrapper {...props}>
      <HeartLogo className={`fill-${heart || 'green'} h2 w2`} />
      <SpeedyGift
        className={`fill-${speedy || 'gray'} border-box ml05 pl2 w4`}
      />
    </Wrapper>
  )
}
